/* global axios */

import ApiClient from './ApiClient';

class CannedResponse extends ApiClient {
  constructor() {
    super('canned_responses', { accountScoped: true });
  }

  get({ searchKey }) {
    const url = searchKey ? `${this.url}?search=${searchKey}` : this.url;
    return axios.get(url);
  }

  create(data) {
    if (data.attachment) {
      const formData = new FormData();
      formData.append('canned_response[short_code]', data.short_code);
      if (data.content)
        formData.append('canned_response[content]', data.content);
      formData.append('canned_response[attachment]', data.attachment);
      return axios.post(this.url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }
    return axios.post(this.url, { canned_response: data });
  }

  update(id, data) {
    if (data.attachment) {
      const formData = new FormData();
      formData.append('canned_response[short_code]', data.short_code);
      if (data.content)
        formData.append('canned_response[content]', data.content);
      formData.append('canned_response[attachment]', data.attachment);
      return axios.patch(`${this.url}/${id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }
    if (data.remove_attachment) {
      const formData = new FormData();
      formData.append('canned_response[short_code]', data.short_code);
      if (data.content)
        formData.append('canned_response[content]', data.content);
      formData.append('canned_response[remove_attachment]', 'true');
      return axios.patch(`${this.url}/${id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }
    return axios.patch(`${this.url}/${id}`, { canned_response: data });
  }
}

export default new CannedResponse();
